<p-dropdown
  #dropdown_ui
  [options]="options"
  [disabled]="isDisabled"
  [placeholder]="placeholder"
  (onChange)="onValueChange($event)"
>
  <ng-content></ng-content>
</p-dropdown>
